import React from 'react';
import { StyleSheet, View } from 'react-native';
import { DateSignals } from '../utils/inventoryDateSignals';

const states = ['unknown', 'warning', 'critical'] as const;
export function dateSignalsLabel(signals: DateSignals | undefined, t: (key: string) => string) {
  return states.filter(state => signals?.[state]).map(state => t(`operations.dateSignal_${state}`)).join(', ');
}

export default function DateStatusDots({ signals, overlay = false }: { signals?: DateSignals; overlay?: boolean }) {
  if (!signals || !states.some(state => signals[state])) return null;
  // The owning button includes the status in its accessible label.
  return <View pointerEvents="none" accessible={false} accessibilityElementsHidden
    importantForAccessibility="no-hide-descendants" style={[styles.row, overlay && styles.overlay]}>
    {states.filter(state => signals[state]).map(state =>
      <View key={state} testID={`date-signal-${state}`} style={[styles.dot, styles[state]]} />)}
  </View>;
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 2, flexShrink: 0 },
  overlay: { position: 'absolute', top: 2, right: 2 },
  dot: { width: 5, height: 5, borderRadius: 3 },
  unknown: { backgroundColor: '#6B7280' },
  warning: { backgroundColor: '#EAB308' },
  critical: { backgroundColor: '#DC2626' },
});
